$(document).ready(function () {
  $(".cst-custom-menudropdown button.dropbtn").click(function () {
    $("nav.site-navigation .navmenu-id-more").css("--menu-closed-height", "0");
    $("nav.site-navigation .navmenu-id-more").css(
      "--menu-open-height",
      "294px"
    );
    $("nav.site-navigation .navmenu-id-more details").attr("open", "open");

    var submenu = $("nav.site-navigation .navmenu-id-more .navmenu-submenu");
    if (submenu.attr("data-animation-state") === "open") {
      submenu.attr("data-animation-state", "closed");
    } else {
      submenu.attr("data-animation-state", "open");
    }
  });
  $("a.cst-custom-popup-content").click(function () {
    $(".cst-custom-model-main").addClass("model-open");
  });
});
